export default __webpack_public_path__ + "static/media/Saima_Ashraf_AHV_In_Moms_We_Trust.1c3bb9d8.jpg";